import type {
  CreateUpdatePeopleRequestDto,
  GetPeopleResponseDto,
  PeopleDto,
  RemovePeopleResponseDto,
} from 'shared/dtos/people.dto';

import { ApiService } from './api.service';

export default class PeopleService extends ApiService {
  getPeople = async (): Promise<GetPeopleResponseDto> => {
    return await this.get(`/peoples`);
  };

  getPerson = async (id: number): Promise<PeopleDto> => {
    return await this.get(`/peoples/${id}`);
  };

  createPeople = async (
    formData: CreateUpdatePeopleRequestDto,
  ): Promise<PeopleDto> => {
    return await this.post('/peoples/', { name: formData.name });
  };

  updatePeople = async (
    id: number,
    formData: CreateUpdatePeopleRequestDto,
  ): Promise<PeopleDto> => {
    return await this.put(`/peoples/${id}`, { name: formData.name });
  };

  removePeople = async (id: number): Promise<RemovePeopleResponseDto> => {
    return await this.remove(`/peoples/${id}`);
  };
}
